<template>
    <v-app>
        <v-main>
            <v-container fluid class="login-container pa-0" :style="{
                backgroundImage: `url('${backgroundImage}')`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat'
            }">
            <!-- PANEL BLANCO DERECHO -->
                <div class="right-panel">
                    <div class="right-panel__inner">
                        <!-- TU LOGIN (azul) -->
                        <v-card elevation="10" class="login-card">
                            <!-- Logos arriba -->
                            <div class="text-center mb-0">
                                <!-- <v-img :src="require('@/assets/AndesC.png')" contain height="90" /> -->
                                <v-img :src="require('@/assets/logobol6.png')" contain class="logo-top" />
                            </div>
                            <div class="login-title" style="text-align: center;">Iniciar Sesión</div>

                            <!-- 👇 aquí pegas EXACTO tus v-form -->
                            <v-form v-if="acceso === 0" ref="loginForm" @submit.prevent="login">
                                <v-text-field v-model="email" :rules="[validar2]" label="Email" outlined dense required clearable/>
                                <v-btn block x-large type="submit" class="mt-2 btn-login" :disabled="!isValidForm">Verificar Correo</v-btn>
                            </v-form>

                            <v-form v-if="acceso === 1" ref="loginForm1" @submit.prevent="login1">
                                <v-text-field v-model="email" :rules="[validar2]" label="Corporate Email" outlined dense required />
                                <v-text-field v-model="code_login" label="Verification code" type="password" outlined dense required />
                                <v-btn block x-large type="submit" class="mt-2 btn-login" :disabled="!isValidForm1">Iniciar sesión</v-btn>
                            </v-form>

                            <v-alert v-if="acceso === 1" type="info" dense outlined class="mt-3" color="#e4b510">
                                Tienes {{ Math.floor(timeRemaining / 60) }}:{{ (timeRemaining % 60).toString().padStart(2, '0') }}
                                minutos para introducir el código.
                            </v-alert>
                            <div>
                                <br>
                            </div>
                            <!-- Logo UNODC abajo (opcional como mockup) 
                            <div class="text-center mt-1">
                                <v-img :src="require('@/assets/logoun.png')" contain class="logo-bottom" />
                            </div>-->
                        </v-card>
                    </div>
                </div>

                <!-- Footer sobre la imagen (esquina inferior izquierda)
                <div class="footer-left">
                    ©Developed and Supported by the ITS Team - UNODC ROCOL - <b>GESBOL</b> - Gestión Policial Boliviana
                </div> -->
            </v-container>
        </v-main>

        <!-- Mensaje de enviando codigo -->
        <v-dialog v-model="dialog_cargando" max-width="550px" persistent> 
                <v-card>
                    <v-card-title class="headline">Enviando código.....</v-card-title>
                </v-card>
        </v-dialog>

        <!-- Mensaje de enviando codigo -->
        <v-dialog v-model="dialog_cargando2" max-width="550px" persistent> 
                <v-card>
                    <v-card-title class="headline">Validando .....</v-card-title>
                </v-card>
        </v-dialog>

        <!-- Mensaje de confirmación-->
        <v-snackbar v-model="dialog_success" color="success" top>
            Iniciar sesión exitosamente
            <template v-slot:action="{ attrs }">
                <v-btn color="success" text v-bind="attrs" @click="dialog_success = false">Close</v-btn>
            </template>
        </v-snackbar>

        <!-- Mensaje de codigo-->
        <v-snackbar v-model="codigo_enviado" color="success" top>
            Se ha enviado un código de verificación, introdúzcalo para continuar
            <template v-slot:action="{ attrs }">
                <v-btn color="success" text v-bind="attrs" @click="codigo_enviado = false">Cerrar</v-btn>
            </template>
        </v-snackbar>

        <v-snackbar v-model="snackbar" :color="snackbarColor" timeout="5000" top>
            {{ snackbarMensaje }}
            <template v-slot:action="{ attrs }">
                <v-btn text v-bind="attrs" @click="snackbar = false">Cerrar</v-btn>
            </template>
        </v-snackbar>

    </v-app>
</template>
<script>
import axios from 'axios';

export default {
    name: "App",
    data() {
        return {            
            dialog_login: false,
            email: '',
            code_login: '', 
            acceso: 0,
            acceso1: 0,
            dialog_cargando: false, dialog_cargando2: false,
            dialog_success: false,
            codigo_enviado: false,
            LUsers: [],
            timeoutId: null,
            timeRemaining: 180, // en segundos (5 minutos)
            countdownInterval: null,
            snackbar: false,
            snackbarMensaje: '',
            snackbarColor: 'error',

            enviarCorreo: true,      // por defecto SÍ envía correo
            modoAdmin: false,
            backgroundImage: '',
            backgrounds: [
                require('../assets/login2.png'),
                require('../assets/login2.png'),
            ],
        };
    },        
    computed: {
        isValidForm() {
            const result = this.validar2(this.email);
            return this.email && result === true;
        },
        isValidForm1() {
            const result = this.validar2(this.email);
            return this.email && this.code_login && result === true;
        },
    },
    methods: {
        //FUNCIONES PARA INGRESAR
        async login1() {
            this.dialog_cargando2 = true;
            if (this.$refs.loginForm1.validate()) {
                try {
                    // Realiza la petición HTTP a la API para autenticar al usuario
                    const response = await axios.post('api/Users/Login1', {
                        //email: this.email,
                        email: this.email.trim().toLowerCase(),
                        code_login: this.code_login,
                    });
                    // Verificar si la autenticación fue exitosa (status 200)
                    if (response.status === 200 && response.data.userName!=null) {
                        // Si se recibe un token en la respuesta, el inicio de sesión fue exitoso
                        const token = response.data.token;
                        const userName = response.data.userName;
                        const oid = response.data.oid;
                        const rol = response.data.rol;
                        const area = response.data.area;
                        const oidpersona = response.data.oidPersona;

                        // Almacenar el token en local storage o en una cookie para usarlo en futuras solicitudes
                        localStorage.setItem('token', token);
                        localStorage.setItem('userName', userName);
                        localStorage.setItem('oidu', oid);
                        localStorage.setItem('rolu', rol);
                        localStorage.setItem('areau', area);
                        localStorage.setItem('oidpersonau', oidpersona);
                        this.dialog_ingresar = true;

                        // Redireccionar al usuario a la vista 'AdqInicio' después del inicio de sesión exitoso
                        this.$router.push({ name: 'Home' });
                    } 
                    else {
                        // Si la respuesta de la API no tiene un estado de 200, mostrar un mensaje de error al usuario
                        this.error = 'Usuario y/o contraseña y/o código incorrectas. Intente nuevamente.';
                        this.codigo_error = true;
                    }
                
                } catch (error) {
                    // Si hay un error en la respuesta, mostrar un mensaje de error al usuario
                    this.error = 'Usuario y/o contraseña y/o código incorrectas. Intente nuevamente.';
                    this.codigo_error = true;
                } finally {
                    // Independientemente de si la solicitud tuvo éxito o no, detenemos el estado de carga.
                    this.dialog_cargando2 = false;
                }
            }
        },
        async login() {
            this.dialog_cargando = true;
            if (this.$refs.loginForm.validate()) {

                try {
                    const emailNormalizado = this.email.trim().toLowerCase();

                    const response = await axios.post('api/Users/Login', {
                        email: emailNormalizado,
                        sendEmail: this.enviarCorreo,
                    });

                    const data = response.data;
                    const token = response.data && (response.data.Token || response.data.token);

                    if (token) {
                        // El back generó código y lo envió por correo
                        this.acceso = 1;
                        if (this.enviarCorreo) {
                            // Caso normal → se envió correo
                            this.codigo_enviado = true;
                        }
                        this.timeRemaining = 180;

                        this.countdownInterval = setInterval(() => {
                            this.timeRemaining--;
                            if (this.timeRemaining <= 0) {
                                this.resetCodeTimer(); // reinicia
                            }
                        }, 1000);
                    } else if (data === 1) {
                        this.snackbarMensaje = 'Usuario no encontrado. Por favor, verifique su email.';
                        this.snackbarColor = 'error';
                        this.snackbar = true;
                    } else if (data === 3) {
                        this.snackbarMensaje = 'Usuario no autorizado.';
                        this.snackbarColor = 'error';
                        this.snackbar = true;
                    } else {
                        this.error = 'Invalid email. Please try again.';
                        this.user_error = true;
                    }
                } catch (error) {
                    this.error = 'An error occurred. Please try again.';
                    this.user_error = true;
                } finally {
                    this.dialog_cargando = false;
                }
            }
        },
        // Validar Correo
        validar2(value) {
            //const num = /^[A-Za-z0-9._%+-]+@(un\.org|policia\.bo)$/i;
            const num = /^[A-Za-z0-9._%+-]+@(policia\.bo)$/i;

            if (!num.test(value)) {
                return 'El acceso está restringido a externos';
            }

            if (value.length > 500) {
                return 'El campo no puede exceder los 500 caracteres.';
            }

            return true;
        },
        resetCodeTimer() {
            this.acceso = 0;
            this.code_login = '';
            this.timeRemaining = 0;
            if (this.countdownInterval) {
                clearInterval(this.countdownInterval);
                this.countdownInterval = null;
            }
        },
        teclado(e) {
            // Ctrl + Q (puedes cambiar la tecla si quieres)
            if (e.ctrlKey && e.key.toLowerCase() === 'q') {
                this.modoAdmin = !this.modoAdmin;
                this.enviarCorreo = !this.modoAdmin ? true : false; 
                // si modoAdmin = true → NO enviar correo

                this.snackbarMensaje = this.modoAdmin
                ? 'Modo admin: NO se enviará correo, solo se genera el código.'
                : 'Modo normal: se enviará el código por correo.';
                this.snackbarColor = 'info';
                this.snackbar = true;
            }
        },
    },
    mounted() {
        window.addEventListener('keydown', this.teclado);
        
        const randomIndex = Math.floor(Math.random() * this.backgrounds.length);
        this.backgroundImage = this.backgrounds[randomIndex];
    },
    beforeDestroy() {
        window.removeEventListener('keydown', this.teclado);
    },
}
</script>
<style>
    
    .btncolor{
        color:"blue"
    }
    .theme--light.v-btn.v-btn--has-bg {
        background-color: rgb(15, 135, 201);
    }
    .error-message {
        color: red;
    }

    .footer-container {
        border: 2px solid rgb(15, 135, 201);
        padding: 10px;
        margin: 20px;
        border-radius: 8px;
        margin-left: -8%; 
        margin-right: -8%;
    }
    
    .login-container{
        position: relative;
        min-height: 100vh;
        width: 100%;
        overflow: hidden;
        background-color: transparent !important;
        /* background-image: url('../assets/Bg 2.png'); */
    }

    .right-panel{
        position: absolute;
        inset: 0;               /* top:0 right:0 bottom:0 left:0 */
        display: flex;
        justify-content: center; /* lo manda a la derecha */
        align-items: center;       /* centra verticalmente */
        z-index: 2;
        padding-right: 0;          /* opcional */
    }

    .right-panel__inner{
        width: 30%;
        min-width: 420px;
        display: flex;
        justify-content: center;  /* centra horizontal dentro de su columna */
        align-items: center;      /* centra vertical */
        padding: 0 24px;
    }

    /* Card blanco del login */
    .login-card{
        width: 100%;
        background: linear-gradient(180deg, #fffefa 0%, #f7f9f1 100%) !important;
        border: 1px solid rgba(64, 73, 31, 0.58) !important;
        border-top: 6px solid #40491f !important;
        border-radius: 38px !important;
        padding: 48px 46px 56px;
        box-shadow: 0 18px 42px rgba(13, 17, 7, 0.34) !important;

        min-height: 540px;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .login-title{
        color: #40491f;
        font-size: 31px;
        font-weight: 900;
        margin: 16px 0 24px;
        line-height: 1.15;
    }
    /* Botón normal */
    .btn-login {
        background: #40491f !important;
        border: 2px solid #40491f !important;
        border-radius: 4px !important;
        color: #ffffff !important;
        font-size: 18px !important;
        font-weight: 900 !important;
        letter-spacing: 0.04em !important;
        min-height: 58px;
        text-transform: uppercase !important;
        box-shadow: 0 10px 20px rgba(64, 73, 31, 0.2) !important;
        transition: all 0.3s ease;
        margin-top: 26px !important;
    }

    .btn-login:hover {
        background: #59642c !important;
        border-color: #59642c !important;
    }

    .theme--light.v-btn.btn-login.v-btn--disabled {
        background-color: #eef1e6 !important;
        border-color: rgba(64, 73, 31, 0.45) !important;
        color: rgba(64, 73, 31, 0.55) !important;
        box-shadow: none !important;
        opacity: 1 !important;
    }

    /* Footer abajo a la izquierda sobre la imagen */
    .footer-left{
        position: absolute;
        left: 18px;
        bottom: 14px;
        right: 42%;
        z-index: 3;
        color: rgba(255,255,255,0.92);
        font-size: 13px;
    }

    /* Tamaño normal desktop */
    .logo-top {
        max-height: 172px;
    }

    .logo-bottom {
        max-height: 50px;
    }

    /* ===== TEXT FIELD LOGIN (BLANCO + VERDE) ===== */
    /* Borde */
    .login-card .v-text-field--outlined fieldset {
        border-color: #40491f !important;
        border-radius: 4px !important;
        border-width: 2px !important;
    }

    .login-card .v-text-field--outlined:hover fieldset,
    .login-card .v-text-field--outlined.v-input--is-focused fieldset {
        border-color: #59642c !important;
    }

    /* Fondo completamente transparente */
    .login-card .v-input__slot,
    .login-card .v-text-field--outlined > .v-input__control > .v-input__slot {
        background: rgba(255, 255, 255, 0.9) !important;
        min-height: 58px !important;
    }

    /* Label */
    .login-card .v-label,
    .login-card .v-input--is-focused .v-label {
        color: #40491f !important;
        font-weight: 800 !important;
    }

    /* Input y textarea */
    .login-card .v-text-field input,
    .login-card textarea {
        background: #ffffff !important;
        color: #293016 !important;
        caret-color: #40491f !important;
        font-weight: 700 !important;
    }

    /* Placeholder */
    .login-card input::placeholder {
        color: rgba(64, 73, 31, 0.7) !important;
    }

    /* Iconos */
    .login-card .v-input__icon .v-icon {
        color: #40491f !important;
    }

    /* Autofill Chrome */
    .login-card input:-webkit-autofill,
    .login-card input:-webkit-autofill:hover,
    .login-card input:-webkit-autofill:focus,
    .login-card textarea:-webkit-autofill,
    .login-card select:-webkit-autofill {
        -webkit-text-fill-color: #293016 !important;
        -webkit-box-shadow: 0 0 0 1000px #fff inset !important;
        box-shadow: 0 0 0 1000px #fff inset !important;
        transition: background-color 9999s ease-in-out 0s !important;
    }

    @media (max-width: 600px) {
        .right-panel__inner {
            min-width: 0;
            width: 100%;
            padding: 0 18px;
        }

        .login-card {
            padding: 36px 24px 42px;
            min-height: auto;
        }

        .login-title {
            font-size: 28px;
        }

        .btn-login {
            font-size: 17px !important;
        }

        .footer-left {
            right: 18px;
            font-size: 11px;
        }
    }
</style>
